import { render, staticRenderFns } from "./post-vacancy.vue?vue&type=template&id=5877cdc2&lang=html&"
import script from "./post-vacancy.vue?vue&type=script&lang=js&"
export * from "./post-vacancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports